import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NX_MODAL_DATA, NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { LayoutBreakPointsService } from '@shared/services/layout-break-points/layout-break-points.service';
import { SharedModule } from '@shared/shared.module';
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { FormatDecimalCoveragePipe } from '@shared/pipes/format-decimal-coverage/format-decimal.pipe';

@Component({
  selector: 'app-sum-insured-input-model',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './sum-insured-input-model.component.html',
  styleUrl: './sum-insured-input-model.component.scss'
})
export class SumInsuredInputModelComponent {

  mobileView: boolean = false;
  sumInsuredEditForm: FormGroup;
  packageBenefitDescription: any;
  mtExtCovDtoList: any;
  sumInsuredDisplay: any;
  sumInsured: any;
  subCoverCode:any;
  decimalFmt: any;

  constructor(
    @Inject(NX_MODAL_DATA) public data: any,
    private dialogRef: NxModalRef<any>,
    private fb: FormBuilder,
    private layoutService: LayoutBreakPointsService,

  ) {
    this.decimalFmt = new FormatDecimalCoveragePipe();
    this.packageBenefitDescription = data.packageBenefitDescription;
    this.mtExtCovDtoList = data.mtExtCovDtoList;
    this.sumInsuredDisplay = data.mtExtCovDtoList[0].label;
    this.subCoverCode = data.subCoverCode; 
    this.sumInsured = data.subCoverSumInsured;
  }
  ngOnInit() {
    this.layoutService.subscribeLayoutChanges().subscribe(() => {
      this.mobileView = !this.layoutService.renderDesktop();
    });

    this.sumInsuredEditForm = this.fb.group({
      sumInsured: [
        this.data.subCoverSumInsured || '',
        [
          Validators.required,
          Validators.min(0.01),
          Validators.pattern(/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/)
        ]
      ]
    });
    if (this.sumInsured > 0) {
      this.sumInsuredEditForm.patchValue({
        sumInsured: this.decimalFmt.transform(this.sumInsured)
      });
    }
    this.sumInsuredEditForm.controls['sumInsured'].updateValueAndValidity();
  }

  cancelEdit() {
    this.dialogRef.close({
          subCoverCode: this.subCoverCode,
          sumInsured: this.sumInsuredEditForm.value.sumInsured
        });
  }
  saveEdit() {
     
      if(this.sumInsuredEditForm.valid) {
        this.dialogRef.close({
          subCoverCode: this.subCoverCode,
          sumInsured: this.sumInsuredEditForm.value.sumInsured
        });        
      }else {
        let invalidControls = [];
        const controls = this.sumInsuredEditForm.controls;
  
        for(const name in controls) {
          if(controls[name].invalid) {
            invalidControls.push(name);
          }
        }
        console.warn("invalid edit form: ", invalidControls);
        this.sumInsuredEditForm.markAllAsTouched();
        ScrollToError.scrollToError('.ng-invalid[formControlName]');
      }  
  }

  onChangeSubCoverSumInsured(subCoverSumInsuredValue: any) {
    if (!Number.isInteger(parseFloat(subCoverSumInsuredValue.value))){
      this.sumInsuredEditForm.controls["sumInsured"].markAsTouched();
      return;
    }

    let formatSubCoverSumInsuredValue = subCoverSumInsuredValue.value.toString().replace(/,/g, "") ?? 0.00;

    let formattedValue = this.decimalFmt.transform(parseFloat(formatSubCoverSumInsuredValue).toFixed(2));
    if (/^(?!0(?:\.0{1,2})?$)(\d{1,8}(,\d{3})*)(\.\d{1,2})?$/.test(formatSubCoverSumInsuredValue)) {
      console.log("Valid format: 11 characters with 2 decimal places");
    } else {
      if (!Number.isInteger(parseFloat(subCoverSumInsuredValue.value.substring(0, 1)))) {
        this.sumInsuredEditForm.patchValue({
          sumInsured: formattedValue
        });
      } else {
        const existingErrors = this.sumInsuredEditForm.get('sumInsured')?.errors;
        this.sumInsuredEditForm.get('sumInsured')?.setValue(formattedValue);
        this.sumInsuredEditForm.get('sumInsured')?.setErrors(existingErrors);
      }
      this.sumInsuredEditForm.controls["sumInsured"].markAsTouched();
      return;
    }
    if (formatSubCoverSumInsuredValue > 0) {
      this.sumInsuredEditForm.patchValue({
        sumInsured: formattedValue
      });
    }
  }
}
